import {ListUserManagementUsersQueryParams} from "@project/sdk/user-management/zod";
import type {z} from "zod";

export const listUserManagementUsersSearchSchema = ListUserManagementUsersQueryParams.extend({
  page: ListUserManagementUsersQueryParams.shape.page.catch(1).default(1),
  perPage: ListUserManagementUsersQueryParams.shape.perPage.catch(20).default(20),
  sortDir: ListUserManagementUsersQueryParams.shape.sortDir.catch("asc"),
  q: ListUserManagementUsersQueryParams.shape.q.catch(undefined),
  sortKey: ListUserManagementUsersQueryParams.shape.sortKey.catch(undefined),
  accessState: ListUserManagementUsersQueryParams.shape.accessState.catch(undefined),
  invitationState: ListUserManagementUsersQueryParams.shape.invitationState.catch(undefined),
  identityBindingState:
    ListUserManagementUsersQueryParams.shape.identityBindingState.catch(undefined),
  provisioningStatus: ListUserManagementUsersQueryParams.shape.provisioningStatus.catch(undefined),
});
export type ListUserManagementUsersSearchInput = z.input<
  typeof listUserManagementUsersSearchSchema
>;
export type ListUserManagementUsersSearch = z.output<typeof listUserManagementUsersSearchSchema>;
